const dataRequestForm = {
  title: "Create Data Request",
  errors: {
    loadProjectsFailed: "Failed to load projects",
    loadDatasetsFailed: "Failed to load datasets",
    selectDatasetRequired: "Please select a dataset",
    selectColumnRequired:
      "Select at least one column, or clear the column selection to request the whole file",
    createFailed: "Failed to create data request",
  },
  success: {
    createdAndForwarded: "Data request created and forwarded successfully!",
    createdForwardFailed:
      "Data request created, but failed to forward. You can forward it manually from the request details.",
    created: "Data request created successfully!",
  },
  fields: {
    project: {
      label: "Project *",
      placeholder: "Select a project",
    },
    sourceType: {
      label: "Data Source Type *",
      upload: "Request new dataset",
      dataset: "Select from existing datasets",
    },
    title: {
      label: "Request Title *",
      placeholder: "e.g., Patient data for cardiovascular study",
    },
    description: {
      label: "Description *",
      defaultText: "Request for data from {{datasetName}}",
    },
    requestedFields: {
      label: "Requested fields (optional)",
      placeholder: "kennitala, first_name, last_name\nor one per line",
      hint: "Leave blank to request every field in the file.",
    },
    processingNotes: {
      label: "Notes for the data provider (optional)",
      placeholderDataset:
        "Anything the reviewer should know — e.g. only adults, or flag that the age column has mixed units",
      placeholderUpload:
        "Filter criteria in your own words, or data quality issues to watch for",
    },
  },
  dataset: {
    sectionTitleLocked: "Dataset",
    sectionTitle: "Select Dataset *",
    loading: "Loading datasets…",
    searchPlaceholder: "Search datasets by name…",
    selectedPlaceholder: "Selected: {{name}}",
    noneAvailable: "No datasets available to request",
    noMatch: "No datasets match your search",
    rows: "rows",
    rowsUnknown: "N/A",
    columns: "columns",
    clear: "Clear",
    browseCatalog: "Browse full catalog →",
    browseCatalogHint: "to explore datasets with filters",
  },
  advanced: {
    toggle: "Advanced options",
    hint: "narrow to specific columns or value ranges",
    selectDatasetNote: "Select a dataset above to choose columns and filters.",
    noColumnMetadata:
      "This dataset has no column metadata, so it can only be requested in full.",
  },
  columns: {
    label: "Columns",
    countAll: "all {{count}}",
    countSelected: "{{selected}} of {{total}}",
    countFiltered: " · {{count}} filtered",
    selectAll: "Select all",
    clear: "Clear",
    clearFilters: "Clear filters",
    headerColumn: "Column",
    headerType: "Type",
    headerFilter: "Filter",
    includeAria: "Include {{column}}",
    personalData: "Personal data",
    personalDataTitle: "Personal data — values are pseudonymized",
    identifier: "Identifier",
    identifierTitle: "Identifier column — will be pseudonymized",
    notFilterable: "Not filterable",
    notFilterableTitle:
      "Personal-data columns are pseudonymized, so their original values cannot be filtered on",
    minAria: "Minimum {{column}}",
    maxAria: "Maximum {{column}}",
    rangeTitle: "Range {{min}} – {{max}}",
    categoriesAria: "Categories for {{column}}",
  },
  redirect: {
    toggle: "Optionally forward to data provider on creation",
    description:
      "Select data providers to forward this request to immediately after creation:",
    dataProviders: "Data Providers",
    organizations: "Organizations",
    notesLabel: "Forwarding note (optional)",
    notesPlaceholder: "e.g., 'Patient records for Q4 study'",
    defaultNote: "Request created and forwarded to data provider",
  },
  submit: {
    submitting: "Submitting Request...",
    submit: "Submit Data Request",
  },
};

export default dataRequestForm;
